import React from 'react';
export class RemoteComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static displayName = 'RemoteComponent';
    static getDerivedStateFromError(_error) {
        return { hasError: true };
    }
    // public componentDidCatch(error, errorInfo) {
    //   // logErrorToService(error, errorInfo)
    // }
    render() {
        if (this.state.hasError) {
            return (this.props.errorComponent || (React.createElement("div", { "data-testid": this.props.testId && `${this.props.testId}-error` }, "There was an error")));
        }
        return (React.createElement(React.Suspense, { fallback: this.props.delayedComponent || React.createElement("div", { "data-testid": this.props.testId && `${this.props.testId}-delay` }) }, this.props.children));
    }
}
